<template>
  <div>
    <Banner />
    <section class="hero">
      <h2>Positive Grid Artists</h2>
      <h4>艺人介绍</h4>
    </section>
    <section class="artists">
      <router-link to="/artist/acey">
        <img
          class="artists-image"
          src="@/assets/artist/artist-acey@2x.png"
        >
        <div class="desc">
          <h4>ACEY SLADE</h4>
          <p>DOPE | MURDERDOLLS | JOAN JETT</p>
        </div>
      </router-link>
      <router-link to="/artist/joey">
        <img src="@/assets/artist/artist-joey@2x.png">
        <div class="desc">
          <h4>JOEY BRADFORD</h4>
          <p>THE USED</p>
        </div>
      </router-link>
      <router-link to="/artist/stef">
        <img src="@/assets/artist/artist-stef@2x.png">
        <div class="desc">
          <h4>STEF CARPENTER</h4>
          <p>DEFTONES</p>
        </div>
      </router-link>
      <router-link to="/artist/rob">
        <img src="@/assets/artist/artist-rob@2x.png">
        <div class="desc">
          <h4>ROB CAGGIANO</h4>
          <p>VOLBEAT</p>
        </div>
      </router-link>
    </section>
    <footer-common />
  </div>
</template>

<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'

export default {
  name: 'Index',
  components: { Banner, FooterCommon },
  data () {
    return {}
  },
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>

<style scoped>
section.hero > img {
  max-height: 440px;
  background-size: cover;
  width: 100%;
}
section.hero > div {
  text-align: center;
  background-image: linear-gradient(266deg, #111111, #0d0d0d);
  padding: 40px;
}
section.hero > div > h3 {
  margin: 0;
}

.artists {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.artists > a {
  flex-grow: 1;
  width: 40%;
  position: relative;
  margin: 5%;
}

.desc {
  position: absolute;
  bottom: 0;
  height: 26%;
  width: 100%;
  background-color: black;
  opacity: 0.8;
  padding-left: 5%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.desc > * {
  padding: 0;
  margin: 0;
  color: white;
}

.desc > h4 {
  font-size: 24px;
}
.desc > p {
  font-size: 14px;
}
.desc > a {
  font-size: 16px;
}

.artists > a > img {
  max-width: 100%;
  max-height: 100%;
}

section.hero {
  background-image: url(../assets/artist/artist-banner@2x.png);
  min-height: 540px;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: 600;
  color: white;
}

section.hero h2,
section.hero h4 {
  padding: 0;
  margin: 0;
}
@media screen and (max-width: 768px) {
  section.hero {
    min-height: 300px;
    background-position: center top;
    background-size: cover;
    overflow: hidden;
  }
  .artists {
    width: 95%;
  }
  .artists > a {
    width: 90%;
    margin: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/artist.vue